module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.title,
      "onClick": _vm.onSelect,
      "withBody": _vm.isDisplayDetails,
      "withFooter": _vm.isDisplayDetails,
      "to": {
        name: 'order',
        params: {
          identifier: _vm.order.marketplace.identifier,
          code: _vm.order.marketplace.code
        }
      }
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.order.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.order.status).label))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md l-col-offset-3@md"
  }, [_c('stepper', {
    attrs: {
      "order": _vm.order.marketplace
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('blockquote', {
    staticClass: "l-col-4@md box first"
  }, [(_vm.order.customer) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('name.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.name))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('phone.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.phone))) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.isPersonal ? 'CPF' : 'CNPJ'))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.documentNumber))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('phoneMobile.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.hideData(_vm.order.customer.mobile))) + "\n            ")])])]) : _c('div', {
    staticClass: "l-row full-height u-textCenter"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "vertical-center"
  }, [_c('span', [_vm._v("Dados do cliente não informados")])])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-4@md box"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('identifier.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.order.marketplace.externalReference)) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('date.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.adjustDate)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shipmentService.name.label')))]), _vm._v(" "), _c('span', {
    staticClass: "badge queue"
  }, [_vm._v(_vm._s(_vm._f("attribute")(_vm.$t(("shipmentService." + (_vm.order.marketplace.shipmentService) + ".label")))))])]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('channel.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm.channel)) + "\n            ")]), _vm._v(" "), _vm._t("attributes")], 2)])]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-4@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('subtotal.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm._f("currency")(_vm.order.payment.subtotal))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('shippingPrice.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm._f("currency")(_vm.order.payment.shipping))) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('discount.label')))]), _vm._v("\n              " + _vm._s(_vm._f("attribute")(_vm._f("currency")(_vm.order.payment.discount))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('total.label')))]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm._f("attribute")(_vm._f("currency")(_vm.order.payment.total))))])])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('module-icon', {
    attrs: {
      "identifier": _vm.order.marketplace.identifier
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa2fb37","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Shared/OrderCard.vue
// module id = 3214
// module chunks = 0